export default [
  {
    title: 'Resultados de ofertas de trade',
    subtitle: 'Ativar essa opção significa que o filiado pode visualizar o resultado de ofertas de trade dentre de suas lojas.',
    permission: 'view_offers_schedule_trade_results',
  },
]
